import ModalFactory from '../factory';

import Content from './KeyboardShortcutsHelpModal';

const KeyboardShortcutsHelpModal = ModalFactory(Content);

export default KeyboardShortcutsHelpModal;
